// Mirror exports for the web bundle so `@/shared/ranks` works in web.
export type RankTitle =
  | "Initiate"
  | "Apprentice"
  | "Acolyte"
  | "Mage"
  | "Sorcerer"
  | "Wizard"
  | "Archmage"
  | "Master of the Arcane"
  | "Mystic Sage"
  | "Supreme Sorcerer"
  | "Elder Archmage";

export const RANK_THRESHOLDS: Array<{ title: RankTitle; min: number }> = [
  { title: "Initiate", min: 0 },
  { title: "Apprentice", min: 5 },
  { title: "Acolyte", min: 10 },
  { title: "Mage", min: 20 },
  { title: "Sorcerer", min: 30 },
  { title: "Wizard", min: 50 },
  { title: "Archmage", min: 80 },
  { title: "Master of the Arcane", min: 120 },
  { title: "Mystic Sage", min: 160 },
  { title: "Supreme Sorcerer", min: 220 },
  { title: "Elder Archmage", min: 300 },
];

export function getRankTitle(points: number): RankTitle {
  const p = Math.max(0, Number(points || 0));
  let current = RANK_THRESHOLDS[0].title;
  for (const r of RANK_THRESHOLDS) {
    if (p >= r.min) current = r.title;
    else break;
  }
  return current;
}
export function nextThreshold(points: number): { title: RankTitle; min: number } | null {
  const p = Math.max(0, Number(points || 0));
  for (const r of RANK_THRESHOLDS) {
    if (p < r.min) return r;
  }
  return null;
}
export const GRAND_ARCANIST_UIDS = new Set<string>([
  "hOCjOiovScaFz4f54LCl6ec5gnB3",
  "evictme",
]);
export function isGrandArcanist(opts?: { uid?: string | null; username?: string | null }): boolean {
  const uid = String(opts?.uid || "").trim();
  const name = String(opts?.username || "").trim().toLowerCase();
  return GRAND_ARCANIST_UIDS.has(uid) || name === "evictme";
}
export function getDisplayRankTitle(
  points: number,
  opts?: { uid?: string | null; username?: string | null }
): string {
  return isGrandArcanist(opts) ? "Grand Arcanist" : getRankTitle(points);
}
